
import { Paper, Table, TableRow, TableCell, TablePagination, TableSortLabel } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

//#region StyledPaper
export const StyledPaper = withStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
}))(Paper);
//#endregion

//#region StyledTable
export const StyledTable = withStyles((theme) => ({
  root: {
    width: '100%',
    fontFamily: "Open Sans",
    minWidth: 750,
  },
}))(Table);
//#endregion

//#region StyledTableRow
export const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.action.hover,
    },
    // Add this for header row
    '&.MuiTableRow-head': {
      borderBottom: '3px solid var(--primary-color)',
    },
  },
}))(TableRow);
//#endregion

//#region StyledTabelCell
export const StyledTableCell = withStyles(() => ({
  head: {
    fontSize: '.9rem',
    padding: '7px 12px',
    color: '#000000',
    backgroundColor: 'var(--tertiary-color)',
    // Establish a positioning context so absolutely-positioned children
    // (e.g. the visually-hidden a11y sort text) resolve their containing
    // block to the cell instead of the viewport. Without this, those spans
    // escape the TableContainer's overflow clipping and expand the page
    // width when the cell belongs to a horizontally-scrolled-off column.
    position: 'relative',
  },
  body: {
    fontSize: '.9rem',
    padding: '7px 12px',
    color: '#000000',
    '& a': {
      color: 'var(--primary-color)',
      textDecoration: 'underline',
      cursor: 'pointer',
    }
  },
}))(TableCell);
//#endregion

//#region StyledTablePagination
export const StyledTablePagination = withStyles(() => ({
  root: {
    color: 'black',
    '&:focus': {
      color: 'red',
    },
    '& .MuiButtonBase-root': {
      disableRipple: true,
    },
    '& .MuiButtonBase-root:hover': {
      backgroundColor: '#006778',
      color: 'white',
      opacity: '1',
    },
    '& .Mui-focused': {
      outline: '#bb4d00 solid 3px',
      color: 'black',
      opacity: '1',
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'white',
    }
  },
}))(TablePagination);
//#endregion

//#region StyledTableSortLabel
export const StyledTableSortLabel = withStyles(() => ({
  root: {
    color: 'black',
    '&:hover': {
      color: '#006778',
      opacity: '1',
    },
    '&:focus-visible': {
      outline: '#bb4d00 solid 3px',
      color: 'black',
    },
  },
  icon: {
    color: 'inherit !important'
  },

}))(TableSortLabel);
//#endregion